import styled from 'styled-components';
import { media } from 'ia-react-core';
import ContactInformation from '../../ContactInformation';

export const StyledSection = styled.section`
  display: flex;
  flex-flow: wrap;
  ${media.lg`
    padding-left: 12px;
  `};
`;

export const StyledContactInformation = styled(ContactInformation)`
  padding-bottom: 24px;
  padding-right: 16px;
  flex: 1 0 200px;
  min-width: 40%;
  max-width: none;
  &:last-child {
    padding-bottom: 0;
  }
  &:first-child {
    padding-bottom: 0;
  }
`;
